import { render, staticRenderFns } from "./PostsList.vue?vue&type=template&id=4973e4a2&scoped=true"
import script from "./PostsList.vue?vue&type=script&lang=js"
export * from "./PostsList.vue?vue&type=script&lang=js"
import style0 from "./PostsList.vue?vue&type=style&index=0&id=4973e4a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4973e4a2",
  null
  
)

export default component.exports